module.exports = __webpack_public_path__ + "static/07-5222f2147072119347aafeab74d3e9d4.jpg";